import { Ref, watch } from 'vue';
//import useDrawer from '../use-drawer';
import { PageState } from 'primevue/paginator';
import { AppCoreEnums } from '../../shared/enums';
import useConfirmation from '../use-confirmation';
import { useCoreStore } from '../../../stores/core/store';
import useRouterUtils from '../../router-utils/route-utils';
import useRouteResolver from '../router/use-route-resolver';
import useDrawerResolver from '../../router-utils/drawer-resolver';
import useNotifications from '../../../core/composable/use-notifications';
import { DrawerContainerData, Pagination, ToastNotificationAction } from '../../../stores/core/models';
import { DataTableColumnReorderEvent, DataTableRowReorderEvent, DataTableSortEvent } from 'primevue/datatable';

export default (pagination: Ref<Pagination>, containerType: AppCoreEnums.ContainerType) => {
  const coreStore = useCoreStore();
  //const { showDrawer } = useDrawer();
  const { showConfirmation } = useConfirmation();
  const { resolveDrawerData } = useDrawerResolver();
  const { getContainerRouteMeta } = useRouterUtils();
  const meta = getContainerRouteMeta(containerType);
  const { showSuccess, showError } = useNotifications();
  const { runContainerRouteResolve } = useRouteResolver();
  const tableBasedContainerData = coreStore.getTableBasedContainerData(containerType);

  const onColReorder = (event: DataTableColumnReorderEvent) => {
    //showSuccess('Column Reordered', 'info');
  };
  const onRowReorder = (event: DataTableRowReorderEvent) => {
    //showSuccess('Rows Reordered', 'info');
  };

  const onSort = (event: DataTableSortEvent) => {
    const newPagination = {
      ...pagination.value,
      sortBy: event.sortField,
      descending: event.sortOrder == -1,
    } as Pagination;

    onPaginationChanged(newPagination);
  };

  const onPage = (event: PageState) => {
    const newPagination = {
      ...pagination.value,
      page: event.page + 1,
      rowsPerPage: event.rows,
    } as Pagination;

    onPaginationChanged(newPagination);
  };

  const onPaginationChanged = (newPagination: Pagination) => {
    runRouteResolve(newPagination);
  };

  const onSearchChanged = () => {
    runRouteResolve();
  };

  const onRefresh = () => {
    runRouteResolve();
  };

  const onDelete = () => {
    //if (!meta.value.delete) return;

    const selectedKeys = tableBasedContainerData.value?.selectedKeys || [];
    if (!selectedKeys.length) return;

    // prevent re-entrancy / double-trigger
    if ((onDelete as any)._inProgress) return;

    showConfirmation('core.deleteConfirmation').then((result) => {
      if (result == AppCoreEnums.ConfirmationResult.Yes) {
        (onDelete as any)._inProgress = true;
        coreStore
          .deleteEntities(tableBasedContainerData.value.options.modelClassName, selectedKeys)
          .then((deletedNumber: number) => {
            if (deletedNumber == selectedKeys.length) {
              tableBasedContainerData.value?.resetSelectedData();
              const notifications = tableBasedContainerData.value?.options.notifications;

              var notificationAction = new ToastNotificationAction();
              notificationAction.label = 'core.restore';
              notificationAction.callback = () => {
                coreStore
                  .restoreEntities(tableBasedContainerData.value.options.modelClassName, selectedKeys)
                  .then((restoredNumber: number) => {
                    showSuccess(
                      notifications?.successfullyRestoredTitle || 'core.restoreSuccessfullyDoneMessage',
                      notifications?.successfullyRestoredMsg || 'core.restoreSuccessfullyDoneTitle',
                      selectedKeys.length
                    );
                    runRouteResolve();
                  });
              };

              showSuccess(
                notifications?.successfullyDeleteMsg || 'core.deleteSuccessfullyDoneMessage',
                notifications?.successfullyDeleteTitle || 'core.deleteSuccessfullyDoneTitle',
                selectedKeys.length,
                notificationAction
              );
              runRouteResolve();
            } else {
              // Partial delete or failure: show no success toast for partial; show error only if none were deleted
              if (deletedNumber > 0) {
                tableBasedContainerData.value?.resetSelectedData();
                runRouteResolve();
              } else {
                showError('core.deleteFailedMessage', 'core.deleteFailedTitle');
              }
            }
          })
          .finally(() => {
            (onDelete as any)._inProgress = false;
          });
      }
    });
  };

  const runRouteResolve = (newPagination: Pagination | undefined = undefined) => {
    switch (containerType) {
      case AppCoreEnums.ContainerType.DrawerContainer:
        const resolveDrawerParams = (tableBasedContainerData.value as DrawerContainerData).resolveDrawerParams;
        if (resolveDrawerParams) {
          resolveDrawerParams.resolveParams.pagination = newPagination;
          resolveDrawerParams.resolveParams.useStoreData = true;
          resolveDrawerData(resolveDrawerParams);
        }
        break;
      default:
        runContainerRouteResolve(newPagination, containerType);
        break;
    }
  };

  watch(
    () => tableBasedContainerData.value?.refreshRequestCount,
    () => runRouteResolve()
  );

  return {
    onSort,
    onPage,
    onDelete,
    onRefresh,
    onColReorder,
    onRowReorder,
    onSearchChanged,
  };
};
